module.exports = {
  "/dynamic": {
    "name": "dynamic widget page",
    "success": {
      "comprehensive strategy": [
        "DYNAMIC_WIDGET_PAGE_LOADED",
        "COMPREHENSIVE_STRATEGY_LOADED"
      ],
      "comprehensive strategy not found": [
        "DYNAMIC_WIDGET_PAGE_LOADED",
        "COMPREHENSIVE_STRATEGY_NOT_FOUND"
      ],
      "fast strategy": [
        "DYNAMIC_WIDGET_PAGE_LOADED",
        "FAST_STRATEGY_LOADED"
      ],
      "fast strategy not found": [
        "DYNAMIC_WIDGET_PAGE_LOADED",
        "FAST_STRATEGY_NOT_FOUND"
      ]
    },
    "error": [
      "DYNAMIC_WIDGET_PAGE_ERROR",
      "COMPREHENSIVE_STRATEGY_ERROR",
      "FAST_STRATEGY_ERROR"
    ]
  },
  "/static": {
    "name": "static widget page",
    "success": {
      "default variant": [
        "STATIC_WIDGET_PAGE_LOADED",
        "STATIC_RESULTS_LOADED"
      ],
      "default variant not found": [
        "STATIC_WIDGET_PAGE_LOADED",
        "STATIC_RESULTS_NOT_FOUND"
      ],
      "default variant forbidden": [
        "STATIC_WIDGET_PAGE_LOADED",
        "STATIC_RESULTS_FORBIDDEN"
      ],
      "video only variant": [
        "STATIC_WIDGET_PAGE_LOADED",
        "STATIC_VIDEO_LOADED"
      ],
      "static public page": [
        "STATIC_PUBLIC_WIDGET_PAGE_LOADED",
        "STATIC_RESULTS_LOADED"
      ],
      "static public page not found": [
        "STATIC_PUBLIC_WIDGET_PAGE_LOADED",
        "STATIC_RESULTS_NOT_FOUND"
      ],
      "static public page forbidden": [
        "STATIC_PUBLIC_WIDGET_PAGE_LOADED",
        "STATIC_RESULTS_FORBIDDEN"
      ],
      "static public page video only variant": [
        "STATIC_PUBLIC_WIDGET_PAGE_LOADED",
        "STATIC_VIDEO_LOADED"
      ]
    },
    "error": [
      "STATIC_RESULTS_PAGE_ERROR"
    ]
  },
  "/recommendations": {
    "name": "recommendations page",
    "success": {
      "ranked recommendations loaded": [
        "RECOMMENDATIONS_PAGE_LOADED",
        "RECOMMENDATIONS_RESULTS_LOADED_RANKED"
      ],
      "search recommendations loaded": [
        "RECOMMENDATIONS_PAGE_LOADED",
        "RECOMMENDATIONS_RESULTS_LOADED_SEARCH"
      ],
      "default recommendations loaded": [
        "RECOMMENDATIONS_PAGE_LOADED",
        "RECOMMENDATIONS_RESULTS_LOADED"
      ],
      "ranked recommendations empty": [
        "RECOMMENDATIONS_PAGE_LOADED",
        "RECOMMENDATIONS_RESULTS_EMPTY_RANKED"
      ],
      "search recommendations empty": [
        "RECOMMENDATIONS_PAGE_LOADED",
        "RECOMMENDATIONS_RESULTS_EMPTY_SEARCH"
      ],
      "default recommendations empty": [
        "RECOMMENDATIONS_PAGE_LOADED",
        "RECOMMENDATIONS_RESULTS_EMPTY"
      ]
    },
    "error": [
      "RECOMMENDATIONS_PAGE_ERROR",
      "RECOMMENDATIONS_RESULTS_ERROR_RANKED",
      "RECOMMENDATIONS_RESULTS_ERROR_SEARCH",
      "RECOMMENDATIONS_RESULTS_ERROR"
    ]
  }
};